import { HttpParameterCodec } from '@angular/common/http';

/**
 * When using HttpParams, Angular does not encode all special characters (e.g. '/' and '?' are not encoded).
 * This class can be passed as encoder so that these characters are encoded as well.
 */
export class UrlComponentHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
